import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { PremiumMonthlyInfo } from '@cms-max/medicare-api-sdk'
import { AccordionCard } from 'components/AccordionCard/AccordionCard'

import classes from './MonthlyPremiumCard.module.scss'

type MonthlyPremiumCardProps = {
  className?: string
  monthlyPremium: PremiumMonthlyInfo
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  open?: boolean
  /**
   * Callback fired when the open/close state is changed.
   *
   */
  onChange?: () => void
}
export function MonthlyPremiumCard ({ className, monthlyPremium, open, onChange }: MonthlyPremiumCardProps) {
  const { t } = useTranslation('premiumsMonthly', { keyPrefix: 'PremiumCard' })
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

  const total = formatter.format(monthlyPremium.total)
  const monthString = (new Date(monthlyPremium.date.year, monthlyPremium.date.month - 1, 15)).toLocaleString('en-US', { month: 'long', year: 'numeric' })
  const heading = (
    <div className='ds-u-display--flex ds-u-justify-content--start'>
      <div>
        <div className='ds-text-body--md ds-u-margin--0'>
          {t('premiumAmount')}
        </div>
        <div className='ds-text-body--lg ds-u-font-weight--semibold'>
          {total}
        </div>
      </div>
      <div className='ds-u-margin-x--4'></div>
      <div>
        <div className='ds-text-body--md ds-u-margin--0'>
          {t('date')}
        </div>
        <div className='ds-text-body--lg'>
          {t('month', { month: monthString })}
        </div>
      </div>
    </div>
  )

  return (
    <AccordionCard heading={heading} open={open} onChange={onChange} className={className}>
      <table className={classNames('ds-u-text-align--left', classes.table)}>
        <tbody>
        <tr>
          <th>{t('table.partBAmount')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partB.amount)}</td>
        </tr>
        <tr>
          <th>{t('table.partBLateEnrollmentPenalty')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partB.lateEnrollmentPenalty)}</td>
        </tr>
        <tr>
          <th>{t('table.partBIrmaa')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partB.irmaaAmount)}</td>
        </tr>
        <tr>
          <th>{t('table.maPartB')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partB.maPlanPayment)}</td>
        </tr>
        <tr>
          <th>{t('table.partAAmount')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partA.amount)}</td>
        </tr>
        <tr>
          <th>{t('table.partALateEnrollmentPenalty')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partA.lateEnrollmentPenalty)}</td>
        </tr>
        <tr>
          <th>{t('table.partDIrmaa')}</th>
          <td className='ds-u-text-align--right'>{formatter.format(monthlyPremium.partD.irmaaAmount)}</td>
        </tr>
        </tbody>
        <tfoot>
          <tr>
            <th><strong>{t('table.total')}</strong></th>
            <td className='ds-u-text-align--right'><strong>{formatter.format(monthlyPremium.total)}</strong></td>
          </tr>
        </tfoot>
      </table>
    </AccordionCard>
  )
}

export default MonthlyPremiumCard
